module.exports = __webpack_public_path__ + "img/Commerce English Medium.d2e70585.jpg";